// extracted by mini-css-extract-plugin
var _1 = "H5HQB";
var _2 = "mZqBD";
export { _1 as "status-label", _2 as "status-label--colored" }
